import React, { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import ConFieldDetails from './ConFieldDetails';

const CreateIndex = ({ actions, fields }) => {
  const [conFields, setConFields] = useState([]);
  const handleSubmit = values => {
    console.log('values', values);
  };
  const clearForm = () => {};
  const addConField = () => {
    setConFields([
      ...conFields,
      {
        id: conFields.length + 1,
        field: { label: '- Select Field -', value: '' },
        order: { label: '- Select Order -', value: '' },
        saved: false,
      },
    ]);
  };

  const removeConField = fieldId => {
    console.log('fieldId :>> ', fieldId);
    let noOfItem = 1,
      newConFields = [];
    conFields.forEach(conField => {
      console.log('conField :>> ', conField);
      if (fieldId !== conField.id) {
        conField.id = noOfItem;
        newConFields.push(conField);
        noOfItem++;
      }
    });
    setConFields(newConFields);
  };
  const savePConField = (id, conFieldObj) => {
    console.log('conFieldObj', conFieldObj);
    console.log('fieldId :>> ', id);
    conFields.forEach(conField => {
      if (conField.id === id) {
        conField.field = conFieldObj.field;
        conField.order = conFieldObj.order;
        conField.saved = true;
      }
    });
    setConFields(conFields);
  };
  let fieldOptions = fields.map(field => {
    return {
      label: field.fieldName === 'uuid' ? 'ID' : field.placeholder.en,
      value: field.fieldName,
    };
  });
  fieldOptions = [{ label: '- Select Field -', value: '' }, ...fieldOptions];
  return (
    <Formik
      initialValues={{
        name: '',
      }}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        setSubmitting(false);
        clearForm();
        resetForm();
      }}
    >
      {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
        return (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-10 col-lg-10 col-sm-12 col-xs-12">
                <CustomInputWithIcon icon="text" title="Index Name" required={true}>
                  <Field
                    type="text"
                    name="name"
                    className="form-control form-control-sm"
                    placeholder="Index Name"
                  />
                  <ErrorMessage name="name">
                    {msg => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
              <div className="col-md-2 col-lg-2 col-sm-12 col-xs-12 text-right">
                <button
                  type="button"
                  className="btn btn-theme-green btn-sm"
                  onClick={addConField}
                  title="Add Field"
                >
                  <i className="wb webconnect-plus" />
                  &nbsp;Add Field
                </button>
              </div>
              {conFields.map(field => (
                <ConFieldDetails
                  key={field.id}
                  field={field}
                  fieldOptions={fieldOptions}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  savePConField={savePConField}
                  removeConField={removeConField}
                />
              ))}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateIndex;
